var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5627 5.25C12.4712 6.52094 11.5284 7.5 10.5002 7.5C9.47211 7.5 8.52774 6.52125 8.43774 5.25C8.34399 3.92781 9.2618 3 10.5002 3C11.7387 3 12.6565 3.95187 12.5627 5.25Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 9.5C8.46331 9.5 6.50488 10.5116 6.01425 12.4816C5.94925 12.7422 6.11269 13 6.3805 13H14.6196C14.8874 13 15.0499 12.7422 14.9858 12.4816C14.4952 10.48 12.5368 9.5 10.4999 9.5Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24981 5.81063C6.17668 6.82563 5.41481 7.625 4.59356 7.625C3.77231 7.625 3.00919 6.82594 2.93731 5.81063C2.86262 4.75469 3.60418 4 4.59356 4C5.58293 4 6.32449 4.77406 6.24981 5.81063Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43781 9.56289C5.87374 9.30445 5.25249 9.20508 4.59406 9.20508C2.96906 9.20508 1.40343 10.0129 1.01124 11.5863C0.959681 11.7945 1.09031 12.0004 1.30406 12.0004H4.81281",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.6c989ecb2e4a2d313674a5219ef40ed2.svg";
export { ForwardRef as ReactComponent };